import { FONT_FAMILY } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.ChipContainer = styled("div")(() => ({
  userSelect: "none",
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  width: "fit-content",
  borderRadius: 24,
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD,
  fontSize: 14,
  "& svg": {
    width: 16,
    height: 16,
    marginRight: 6,
  },
}));

export default Styled;
